"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _react = require("react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var eventToValue = function eventToValue(ev) {
  return ev.target.value;
};

var useDebouncedChange = function useDebouncedChange(handleChange, defaultValue, data, path) {
  var eventToValueFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : eventToValue;
  var timeout = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 300;

  var _useState = (0, _react.useState)(data !== null && data !== void 0 ? data : defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      input = _useState2[0],
      setInput = _useState2[1];

  (0, _react.useEffect)(function () {
    setInput(data !== null && data !== void 0 ? data : defaultValue);
  }, [data]);
  var debouncedUpdate = (0, _react.useCallback)((0, _debounce["default"])(function (newValue) {
    return handleChange(path, newValue);
  }, timeout), [handleChange, path, timeout]);
  var onChange = (0, _react.useCallback)(function (ev) {
    var newValue = eventToValueFunction(ev);
    setInput(newValue !== null && newValue !== void 0 ? newValue : defaultValue);
    debouncedUpdate(newValue);
  }, [debouncedUpdate, eventToValueFunction]);
  var onClear = (0, _react.useCallback)(function () {
    setInput(defaultValue);
    handleChange(path, undefined);
  }, [defaultValue, handleChange, path]);
  return [input, onChange, onClear];
};

var _default = useDebouncedChange;
exports["default"] = _default;